import type { Translations } from '@/translations';

/** The one emoji per vibe. InputScreen, saved trips and shared trips all read this. */
export const VIBE_EMOJIS: Record<string, string> = {
  hungry: '🍜',
  adventurous: '⚽',
  'must-sees': '📸',
  popular: '🔥',
  'hidden-gems': '💎',
  'feeling-lucky': '🎲',
};

const CUSTOM_VIBE_EMOJI = '✨';

/** Display name and emoji for a vibe key, from the active dictionary. */
export function vibeDisplay(t: Translations, vibe: string): { emoji: string; label: string } | null {
  if (vibe.startsWith('custom:')) return { emoji: CUSTOM_VIBE_EMOJI, label: vibe.slice(7) };
  const label = (t.vibes as Record<string, string | undefined>)[vibe];
  if (!label) return null;
  return { emoji: VIBE_EMOJIS[vibe] ?? '', label };
}
